// extracted by mini-css-extract-plugin
export var box = "_6l-1";
export var checked = "_6l-2";
export var descriptionSpacer = "_6l-9";
export var disabled = "_6l-3";
export var icon = "_6l-6";
export var input = "_6l-0";
export var labelSpacer = "_6l-8";
export var medium = "_6l-5";
export var small = "_6l-4";
export var text = "_6l-7";